import { render, staticRenderFns } from "./usersUpdate.vue?vue&type=template&id=0c4b85b2&scoped=true"
import script from "./usersUpdate.vue?vue&type=script&lang=js"
export * from "./usersUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4b85b2",
  null
  
)

export default component.exports